// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay[data-v-07ec4d53]{background:linear-gradient(0deg,rgba(67,87,92,.75),hsla(0,0%,100%,0) 75%)}.bg-overlay[data-v-07ec4d53]{background:linear-gradient(180deg,transparent 50%,rgba(0,0,0,.35))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
